<template>
  <div class="radish-pic">
    <div class="field-type" style="border:none">
      <span class="label">最在意的前五个条件:</span>
      <TagShow v-if="Array.isArray(project.tagsort)&&project.tagsort.length>0" :tags="project.tagsort"></TagShow>
      <div v-else class="gray-text value company-pre" style="background: #2478b526;">
        <p>暂无数据</p>
      </div>
    </div>
    <div  class="field-type" style="border-bottom: none;padding-bottom:0px;">
      <div v-for="field in fields" :key="field" class="field-type-tag">
        <span class="label">{{translateTag[field]||field}}:</span>
        <div v-if="field==='职能模块'"
            class="flex-row flex-wrap full-width">
          <span
            v-if="project[field]"
            style="margin: 0px 5px 5px 0;line-height: 22px;"
          >{{project[field] || '--'}}</span>
        </div>
        <div v-else-if="project[field]&&project[field].length>0"
            class="flex-row flex-wrap full-width">
          <span
            v-for="item in project[field]"
            :key="item"
            style="margin: 0px 5px 5px 0;line-height: 22px;"
          >{{item}}</span>
        </div>
        <div v-else class="flex-row flex-wrap full-width">
          <span style="margin: 0px 5px 5px 0;line-height: 22px;">--</span>
        </div>
      </div>
      <div class="field-type-tag">
        <span class="label">工作年限:</span>
        <div class="flex-row flex-wrap full-width">
          <span v-if="project.工作年限 && (project.工作年限[0] || project.工作年限[1])" style="line-height: 22px;">{{(project.工作年限[0] || '')+(project.工作年限[0] && project.工作年限[1]?'-':'')+(project.工作年限[1] || '')}}年</span>
          <span v-else style="line-height: 22px;">--</span>
        </div>
      </div>
      <div class="field-type-tag">
        <span class="label">学历要求:</span>
        <div class="flex-row flex-wrap full-width">
          <span v-if="project.学历要求" style="line-height: 22px;">{{project.学历要求}}及以上</span>
          <span v-else style="line-height: 22px;">--</span>
        </div>
      </div>
    </div>
    <div class="field-type" style="padding-bottom: 10px;">
      <span class="label">公司用人偏好:</span>
      <div :class="[company.人员整体情况?'':'gray-text','value company-pre']">
        <p v-if="company.人员整体情况">{{company.人员整体情况}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('人员整体情况')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>

  </div>
</template>
<script>
import TagShow from '../company/TagShow'

export default {
  components: { TagShow },
  props: {
    project: { type: Object, default: () => ({}) },
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['职能模块', '细分职能','擅长方向','地域','目标行业',   '平台', '职级', '业绩'],
      translateTag: {
        标签: '自定义标签',
        人员整体情况:'公司用人偏好',
      },
    }
  },
  methods: {
    openRadish(item) {},
    quickEdit(field){
      const { translateTag, company } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
.radish-pic .field-type {
  padding-top: 0;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
